import type { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies";

let serverCookies: ReadonlyRequestCookies | undefined;
export const getServerCookies = (): ReadonlyRequestCookies | undefined =>
  serverCookies;
export const setServerCookies = (cookies: ReadonlyRequestCookies) =>
  (serverCookies = cookies);
